export default {

    indexDateMasks:     { method: 'get',    url: 'date_masks' },
    storeDateMask:      { method: 'post',   url: 'date_masks' },
    updateDateMask:     { method: 'put',    url: 'date_masks/{id}'},
    destroyDateMask:    { method: 'delete', url: 'date_masks/{id}'},

}